import PropTypes from "prop-types";
import React from "react";

/**
 * Maximize (expand to drawer) glyph — shown while the panel is a popover.
 */
export function MaximizeIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M12.6667 4.66602V0.666016H8.66675M12.6667 0.666016L8.00008 5.33268M0.666748 12.666L5.33341 7.99935M0.666748 8.66602V12.666H4.66675"
        stroke="black"
        strokeOpacity="0.45"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Minimize (restore to popover) glyph — shown while the panel is a drawer.
 */
export function MinimizeIcon({ className }) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
    >
      <path
        d="M9.99967 6.66732L15.833 0.833984M9.99967 1.66732V6.66732H14.9997M0.833008 15.834L6.66634 10.0007M6.66634 15.0007V10.0007H1.66634"
        stroke="black"
        strokeOpacity="0.45"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

MaximizeIcon.propTypes = { className: PropTypes.string };
MaximizeIcon.defaultProps = { className: undefined };
MinimizeIcon.propTypes = { className: PropTypes.string };
MinimizeIcon.defaultProps = { className: undefined };
